(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index__icon-bar"]) return;
  try {
    
  $('.icon-bar-index .icon-bar__block').hover(
    function() {
      $(this).find('.further-details').removeClass('visually-hidden-desktop-only');
      $(this).addClass('expanded');
    }, function() {
      $(this).find('.further-details').addClass('visually-hidden-desktop-only');
      $(this).removeClass('expanded');
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__slideshow-classic"] && !Shopify.designMode) return;
  try {
    
  if (window.location.href.indexOf("prospect%2Cnewsletter&form_type=customer") > -1) {
    $('.newsletter-form__wrapper.shooting-star').addClass('activated');
    $('#mailing-list-star').addClass('activated');
    $('#mailing-list-shooting-star').addClass('activated');

    $('.existing-subscriber').removeClass('visually-hidden');
    $('.form__error:not(.existing-subscriber)').addClass('visually-hidden');
  }

  if (window.location.href.indexOf("customer_posted=true") > -1) {
    $('#mailing-list-star-success').addClass('activated');
    $('#mailing-list-star').addClass('success');
    $('.newsletter-form__wrapper.shooting-star').addClass('success');
    $('#mailing-list-shooting-star').addClass('success');
  }

  $('#mailing-list-star-main').on('click', function() {
    $('.newsletter-form__wrapper.shooting-star').addClass('activated');
    $('#mailing-list-star').addClass('activated');
    $('#mailing-list-shooting-star').addClass('activated');
  });

  $('#mailing-list-star-success').on('click', function() {
    $(this).removeClass('activated');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index__text-with-polaroid"] && !Shopify.designMode) return;
  try {
    
  $('.text-with-polaroid .image-with-text__image-column').mouseover(function() {
    $(this).addClass('rotate-animation');
  }); 

  $('.text-with-polaroid .image-with-text__image-column').on('animationend webkitAnimationEnd', function() {
    $(this).removeClass('rotate-animation');
  });

  } catch(e) { console.error(e); }
})();
})();
